import { render, staticRenderFns } from "./geonotifications.vue?vue&type=template&id=176eeae4&scoped=true"
import script from "./geonotifications.vue?vue&type=script&lang=js"
export * from "./geonotifications.vue?vue&type=script&lang=js"
import style0 from "./geonotifications.vue?vue&type=style&index=0&id=176eeae4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176eeae4",
  null
  
)

export default component.exports